// extracted by mini-css-extract-plugin
export default {"select":"GlossarySelect_select__U6wVh","capitalize":"GlossarySelect_capitalize__7a4HA"};